import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/auth/auth.guard';
import { PageNotFoundComponent } from './page-not-found.component';
import { NoUsageRightComponent } from './no-usage-right.component';
import { NoAdminRightComponent } from './no-admin-right.component';
import { AppLandingComponent } from './app-landing.component';
import { ForbiddenComponent } from './forbidden.component';
import { OpenTargetComponent } from './open-target.component';
import { StatusScreenComponent } from './map/status-screen/status-screen.component';
import { AuthCallbackComponent } from './auth/callback/callback.component';

const appRoutes: Routes = [

    {
        path: 'ProductExtensions',
        loadChildren: () => import('./product-extensions/product-extensions.module').then(m => m.ProductExtensionsModule),
        data: {
            hybridMapHidden: true,
            instructionsHidden: true
        }
    },
    {
        path: 'Settings',
        loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
        data: {
            hybridMapHidden: true,
            instructionsHidden: true
        }
    },
    {
        path: 'SatnetMonitor',
        loadChildren: () => import('./satnet/satnet.module').then(m => m.SatnetModule),
        data: {
            hybridMapHidden: true,
            instructionsHidden: true
        }
    },
    {
        path: 'HeadPowerSettings',
        loadChildren: () => import('./headpower-settings/headpower-settings.module').then(m => m.HeadPowerSettingsModule),
        data: {
            hybridMapHidden: true,
            instructionsHidden: true
        }
    },
    {
        path: 'Worksites',
        loadChildren: () => import('./worksites/worksites.module').then(m => m.WorksitesModule)
    },
    {
        path: 'Tasks',
        loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule)
    },
    {
        path: 'InvoicingProposals',
        loadChildren: () => import('./invoicing-proposals/invoicing-proposals.module').then(m => m.InvoicingProposalsModule)
    },
    {
        path: 'Plans',
        loadChildren: () => import('./plans/plans.module').then(m => m.PlansModule)
    },
    {
        path: 'Tenderings',
        loadChildren: () => import('./tenderings/tenderings.module').then(m => m.TenderingsModule)
    },
    {
        path: 'EndCustomerInvoices',
        loadChildren: () => import('./end-customer-invoices/end-customer-invoices.module').then(e => e.EndCustomerInvoicesModule)
    },
    // TODO 
    { path: 'Login', redirectTo: '/Landing', pathMatch: 'prefix' },  // NOTE: This is just a temporary routing to make things work smoothly when shifting to new login flow. Remove this when not needed anymore.
    // TODO
    { path: 'Landing', data: { hybridMapHidden: true, instructionsHidden: true }, component: AppLandingComponent, canActivate: [AuthGuard] },
    { path: 'OpenTarget/:id', component: OpenTargetComponent, canActivate: [AuthGuard] },
    { path: 'OpenTarget/:id/:target', component: OpenTargetComponent, canActivate: [AuthGuard] },
    { path: 'Status', data: { hybridMapHidden: true, instructionsHidden: true }, component: StatusScreenComponent, canActivate: [AuthGuard] },
    { path: 'NoUsageRight', data: { hybridMapHidden: true, instructionsHidden: true }, component: NoUsageRightComponent },
    { path: 'NoAdminRight', data: { hybridMapHidden: true, instructionsHidden: true }, component: NoAdminRightComponent },
    { path: 'Forbidden', data: { title: 'default.forbidden', hybridMapHidden: true, instructionsHidden: true }, component: ForbiddenComponent },
    { path: 'NotFound', data: { title: 'default.notFound', hybridMapHidden: true, instructionsHidden: true }, component: PageNotFoundComponent },
    { path: 'auth/callback', data: { hybridMapHidden: true, instructionsHidden: true }, component: AuthCallbackComponent },
    { path: '', data: { hybridMapHidden: true, instructionsHidden: true }, redirectTo: '/Landing', pathMatch: 'full' },
    { path: '**', data: { title: 'default.notFound', hybridMapHidden: true, instructionsHidden: true }, component: PageNotFoundComponent }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { scrollPositionRestoration: 'enabled' })
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})
export class AppRoutingModule { }
